import { useLanguage } from '@base/LanguageProvider';
import ModalFooter from '@shared/modal/ModalFooter';
import ModalHeader from '@shared/modal/ModalHeader';
import { ModalBody } from '@styled/Modal';
import React from 'react';
import { useDeleteSheetRow } from '../../../data/sheetRow/sheetRowActions';
import { useSheetRowsById } from '../../../data/sheetRow/sheetRowHooks';
import Manager from '../../modal/Manager';
import Modal from '../../modal/Modal';
function DeleteClusterModal(props) {
    var targetId = props.targetId;
    var L = useLanguage().L;
    var sheetRowsById = useSheetRowsById();
    var deleteSheetRow = useDeleteSheetRow();
    var done = function () {
        deleteSheetRow.mutate(targetId, {
            onSuccess: function () {
                document.location.hash = document.location.hash.replace(/_\d+?(:\d+)?$/, '');
                Manager.closeModal();
            },
        });
    };
    var target = sheetRowsById[targetId];
    var title = (React.createElement("span", null,
        L('Confirm delete operation on row') + ' ',
        React.createElement("b", null,
            "#",
            targetId)));
    return (React.createElement(Modal, { height: "auto", width: "650", closeable: false },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null, target ? (React.createElement("div", null,
            L('Do you really want to delete row') + ' ',
            React.createElement("b", null,
                "#c",
                target.id,
                " - ",
                target.name),
            ' ' + L('and all its subrows and items?'))) : (React.createElement("div", null, L("You don't have access to the referenced rows, so you can't delete it.")))),
        React.createElement(ModalFooter, { cancelLabel: L('Cancel'), done: done, doneLabel: L('Delete'), doneColor: "error" })));
}
export default DeleteClusterModal;
